
import { useParsedFieldProps } from "./useParsedFieldProps";
import { STRING } from "../SchemaTypes";
import { EXCEL_MAXIMUM_CELL_LENGTH } from "../../../helpers/FormValidator";
import Field from "../Field";
import TextareaInput from "../../Input/TextareaInput";

const TextareaField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent } = props;

  const schema = {
    type: STRING,
    parent,
    validations: {
      required,
      length: { maximum: EXCEL_MAXIMUM_CELL_LENGTH }
    }
  };

  return (
    <Field {...fieldProps} schema={schema}>
      <TextareaInput {...inputProps} />
    </Field>
  );
};

export default TextareaField;
